import React from 'react';
import { normalizeDemoChapterKey } from '../data/demoChapterNova';

const PALETTES = {
  fertility: {
    background: '#FBEAF0',
    color: '#993556',
    boxShadow: '0 0 0 1.5px #D4537E, 0 0 0 3.5px #FFFCF9',
  },
  ttc: {
    background: '#EEEDFE',
    color: '#534AB7',
    boxShadow: '0 0 0 1.5px #7F77DD, 0 0 0 3.5px #FFFCF9',
  },
};

function fontSizeForAvatarSize(size) {
  if (size <= 28) return 11;
  if (size <= 32) return 13;
  return 16;
}

/** Maps demo slug / chapter key to NovaAvatar `chapter`: `'ttc'` | `'fertility'`. */
export function novaAvatarChapterFromSlug(slug) {
  return normalizeDemoChapterKey(slug) === 'ttc' ? 'ttc' : 'fertility';
}

export default function NovaAvatar({ chapter = 'fertility', size = 32, style, className, alt = 'Nova' }) {
  const key = chapter === 'ttc' ? 'ttc' : 'fertility';
  const s = PALETTES[key];
  const fontSize = fontSizeForAvatarSize(size);
  return (
    <div
      role="img"
      aria-label={alt}
      className={className}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        borderRadius: '50%',
        background: s.background,
        color: s.color,
        boxShadow: s.boxShadow,
        fontFamily: "'Playfair Display', Georgia, serif",
        fontStyle: 'italic',
        fontWeight: 900,
        fontSize,
        lineHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        boxSizing: 'border-box',
        ...style,
      }}
    >
      N
    </div>
  );
}
